module.exports = __webpack_public_path__ + "media/images/holidaybox/bg-sm-55cf49d19af000882a034fa22244a171.jpg";